// extracted by mini-css-extract-plugin
export default {"services":"services_services__To5tw","cards":"services_cards__D0oyx"};